module.exports = __webpack_public_path__ + "65d2f4fe2e75be794d25aeced447c919.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1146
// module chunks = 0